import { Data, Predicate } from 'effect';

import { ErrorTag } from './index';

export class MissingIdSegmentError extends Data.TaggedError(ErrorTag.MissingIdSegmentError)<{
  readonly segments: readonly string[];
  readonly message: string;
}> {}

export class XRouteNotFoundError extends Data.TaggedError(ErrorTag.XRouteNotFoundError)<{
  readonly message: string;
}> {}

export const isXRouteNotFoundError = (e: unknown): e is XRouteNotFoundError =>
  Predicate.hasProperty(e, '_tag') && e._tag === ErrorTag.XRouteNotFoundError;
